"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveDropVoteSummary } from "@/components/waves/drop/WaveDropVoteSummary";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface CarouselActiveItemVoteProps {
  readonly drop: ExtendedDrop;
  readonly onVoteOpen?: (() => void) | undefined;
  readonly onVoteClose?: (() => void) | undefined;
}
export default function CarouselActiveItemVote(t0) {
  const $ = _c(19);
  const {
    drop,
    onVoteOpen,
    onVoteClose
  } = t0;
  const [isVotingOpen, setIsVotingOpen] = useState(false);
  const [lockedDrop, setLockedDrop] = useState(null);
  const isMobileScreen = useIsMobileScreen();
  const {
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  const modalDrop = lockedDrop ?? drop;
  let t1;
  if ($[0] !== drop || $[1] !== onVoteOpen) {
    t1 = () => {
      setLockedDrop(drop);
      setIsVotingOpen(true);
      onVoteOpen?.();
    };
    $[0] = drop;
    $[1] = onVoteOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenVote = t1;
  let t2;
  if ($[3] !== onVoteClose) {
    t2 = () => {
      setIsVotingOpen(false);
      setLockedDrop(null);
      onVoteClose?.();
    };
    $[3] = onVoteClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCloseVote = t2;
  let t3;
  if ($[5] !== canShowVote || $[6] !== drop || $[7] !== handleOpenVote || $[8] !== isVotingEnded || $[9] !== isWinner) {
    t3 = <WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={isVotingEnded} canShowVote={canShowVote} onVoteClick={handleOpenVote} />;
    $[5] = canShowVote;
    $[6] = drop;
    $[7] = handleOpenVote;
    $[8] = isVotingEnded;
    $[9] = isWinner;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleCloseVote || $[12] !== isMobileScreen || $[13] !== isVotingOpen || $[14] !== modalDrop) {
    t4 = isVotingOpen && (isMobileScreen ? <MobileVotingModal drop={modalDrop} isOpen={true} onClose={handleCloseVote} /> : <VotingModal drop={modalDrop} isOpen={true} onClose={handleCloseVote} />);
    $[11] = handleCloseVote;
    $[12] = isMobileScreen;
    $[13] = isVotingOpen;
    $[14] = modalDrop;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className="tw-mt-4 tw-flex tw-items-center tw-justify-center tw-px-4 md:tw-px-6 lg:tw-px-8">{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}